export enum HandpickChangeField {
    BID = 'bid',
    BUDGET = 'budget',
    STATUS = 'status'
}